import { Explanation, ExplanationStep } from "./models/explanations";

export const getCurrentExplanation = (explanations: Explanation[]) => {
    return explanations.find(ex => ex.steps.some(s => s.finished === false));
}

export const getStepPath = (explanations: Explanation[]): string => {
    const currentExplanation = getCurrentExplanation(explanations);
    const currentStep = getCurrentStep(currentExplanation);

    let stepIndex;
    for (let i = 0; i < currentExplanation.steps.length; i++) {
        const step = currentExplanation.steps[i];

        if (step.id === currentStep.id) {
            stepIndex = i;
            break;
        }
    }

    return `${stepIndex + 1}/${currentExplanation.steps.length}`
}

export const getCurrentStep = (explanation: Explanation) => {
    return explanation?.steps.find(s => s.finished === false);
}

export const finishCurrentStep = (explanations: Explanation[]): Explanation[] => {
    const currentExplanation = getCurrentExplanation(explanations);
    if (currentExplanation) {
        const currentStep = getCurrentStep(currentExplanation);
        if (currentStep) {
            currentStep.finished = true;
        }
    }
    return explanations.map(e => {
        return {
            name: e.name,
            steps: e.steps.map(s => {
                return {
                    title: s.title,
                    id: s.id,
                    anchorId: s.anchorId,
                    placement: s.placement,
                    explanation: s.explanation,
                    finished: s.finished,
                    autoNextId: s.autoNextId
                }
            })
        };
    })
}

export const getAnchorEl = (currentStep: ExplanationStep): HTMLElement => {
    if (currentStep && !currentStep.anchorId) {
        const anchorElId = currentStep?.id;

        if (anchorElId) {
            const el = document.querySelectorAll(`[data-explanation-id="${anchorElId}"]`);
            if (el && el.length > 0) {
                return el[0] as HTMLElement;
            }
        }
    } else if(currentStep) {
        return document.getElementById(currentStep.anchorId);
    }
}